import axiosInstance from '../axiosConfig';

export default {
  async getPhysicalStores(payload) {
    const response = await axiosInstance.post('EcomSeleccionaOficina', payload);
    return response.data;
  },
  async getEstadosList(payload) {
    const response = await axiosInstance.post('EcomSeleccionaEstado', payload);
    return response.data;
  },
};
